import { ServiceCenterPageResource } from "@/api/generated-api";
import ApiClient from "../ampm-world";

export class ApiServiceCenter {
  static async getServiceCenterPage(lang: string): Promise<ServiceCenterPageResource> {
    const data = await ApiClient.get<ServiceCenterPageResource>(`/${lang}/page/service-center`);

    return data;
  }
}
